import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useRouter, usePathname } from 'next/navigation';

const ProtectedRoute = ({ children }) => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const isHydrated = useSelector((state) => state.auth.isHydrated);
  const userType = useSelector((state) => state.auth.userType);
  const businessSetupCompleted = useSelector((state) => state.auth.businessSetupCompleted);
  const router = useRouter();

  const pathname = usePathname();

  // Paths that must remain publicly accessible
  const publicPaths = [
    '/terms',
    '/estimate',
    '/landing',
    '/login',
    '/',
    '/support',
    '/pricing',
    '/about',
    '/privacy',
  ];
  const isPublicPath = pathname && publicPaths.some((p) => pathname.startsWith(p));

  const shouldRedirect = isHydrated && !isLoggedIn && !isPublicPath;

  useEffect(() => {
    if (shouldRedirect) {
      router.replace('/login');
    }
  }, [shouldRedirect, router]);

  // Business setup completion redirect for BUSINESS users
  useEffect(() => {
    if (!isHydrated || !isLoggedIn) return;

    // Only check for BUSINESS users
    if (userType === 'BUSINESS' && businessSetupCompleted === false) {
      // Pages accessible WITHOUT completed business setup
      const businessWhitelist = [
        '/business-setup',
        '/profile',
        '/support',
        '/about',
        '/terms',
        '/logout',
      ];

      const isWhitelisted = businessWhitelist.some((p) => pathname?.startsWith(p));

      // Redirect incomplete business profiles to setup (unless on whitelisted page)
      if (!isWhitelisted) {
        router.replace('/business-setup');
      }
    }
  }, [isHydrated, isLoggedIn, userType, businessSetupCompleted, pathname, router]);

  // Early return for public paths - AFTER all hooks
  if (isPublicPath) return children;

  if (!isHydrated) return null; // Wait for hydration
  if (shouldRedirect) return null;
  return children;
};

export default ProtectedRoute;
